exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".network-header img {\n  float: left;\n  width: 25px;\n  height: 20px; }\n\n.network-header h2 {\n  position: relative;\n  top: -12px;\n  left: 10px; }\n\n.org-vdc-card {\n  float: left;\n  margin: 10px;\n  width: 300px;\n  height: 250px; }\n  .org-vdc-card .vdc-network-icon {\n    width: 25px;\n    height: 20px; }\n  .org-vdc-card .description {\n    margin-top: 0px; }\n  .org-vdc-card .card-item {\n    margin-left: 16px;\n    margin-top: 3px; }\n    .org-vdc-card .card-item .card-label {\n      width: 90px;\n      display: inline-block; }\n  .org-vdc-card .footer {\n    margin-top: 60px; }\n  .org-vdc-card .org-vdc-content {\n    height: 120px; }\n  .org-vdc-card .card-media-text span {\n    color: #007cbb; }\n  .org-vdc-card .card-media-title {\n    font-weight: bold; }\n\n.org-vdc-details {\n  border: none;\n  box-shadow: none;\n  background-color: transparent; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/network/network.scss
// module id = KcWk
// module chunks = 0